import { render, staticRenderFns } from "./issues_list.vue?vue&type=template&id=5ed305da&"
import script from "./issues_list.vue?vue&type=script&lang=js&"
export * from "./issues_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "issues_list.vue"
export default component.exports